"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _vue = _interopRequireDefault(require("vue"));
var _default = exports.default = {
  methods: {
    /** 设置 表单输入控件
     * @description: 表单输入控件
     * @return { void }
     */
    setFormControl: function setFormControl() {
      var _items,
        _items2,
        _Vue$options,
        _this2 = this;
      /* 初始化组件,如果items存在，则多个组件，如果不存在，则作为单个组件 */
      var items = [];
      if (Array.isArray(this.items)) (_items = items).push.apply(_items, (0, _toConsumableArray2.default)(this.items));else items.push(this.items);
      if (Array.isArray(this.formItems)) (_items2 = items).push.apply(_items2, (0, _toConsumableArray2.default)(this.formItems));else items.push(this.formItems);
      items = items.map(function (item) {
        var _item$value;
        (_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : item.value = '';
        return (0, _objectSpread2.default)({}, item);
      });
      var control = [];
      if (Array.isArray(items) && items.length > 0) control = items;else control = [this.$attrs];
      var a = _vue.default === null || _vue.default === void 0 || (_Vue$options = _vue.default.options) === null || _Vue$options === void 0 ? void 0 : _Vue$options.components;
      this.control = control.map(function (item) {
        if ((0, _typeof2.default)(item.control) !== 'object') item.control = {};
        if (item.options) {
          var _item$control, _item$control$options;
          (_item$control$options = (_item$control = item.control).options) !== null && _item$control$options !== void 0 ? _item$control$options : _item$control.options = [];
        }
        return item;
      })
      /* 排序，有排序序号的优先排列，序号越大排得越后，最后才是没有排序序号的原始数据 */.sort(function (_this, _prev) {
        return _this.sortIndex && !_prev.sortIndex ? -1 : _this.sortIndex - _prev.sortIndex;
      });
      this.control.forEach(function (item) {
        var _ref, _item$is, _item$control2, _item$prop, _item$props, _item$rule, _item$rules;
        var is = (_ref = (_item$is = item.is) !== null && _item$is !== void 0 ? _item$is : (_item$control2 = item.control) === null || _item$control2 === void 0 ? void 0 : _item$control2.is) !== null && _ref !== void 0 ? _ref : 'el-input';
        delete item.is;

        /* 判断组件是否存在 */
        if (a && is) {
          if (a[is] || a[_this2.$$handleNameRule(is, 'ucc')]) item.control.is = _this2.$$handleNameRule(is, 'kc');
          // if (a[is] || a[this.$$(is, 'lh')] || a[this.$$(is, 'sh')] || a[this.$$(is, '_')] || a[this.$$(is, '-')]) item.control.is = this.$$alterNomenclature(is, '-')
          else item.control.is = 'el-input';
        }

        /* 默认参数设置 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ */

        if (item.type) _this2.setFormIsControl(item);

        /* 判断是否是时间组件 */
        if (['el-date-picker', 'el-time-picker'].indexOf(item.control.is) > -1) _this2.setFormDateControl(item);
        /* 判断是不是 选择组件 */else if (['el-select', 'el-cascader'].indexOf(item.control.is) > -1) _this2.setFormSelectControl(item);
        /* 判断是不是 开关组件 */else if (['el-switch'].indexOf(item.control.is) > -1) {
          var _item$control3, _activeValue, _item$control3$_activ, _item$control4, _inactiveValue, _item$control4$_inact;
          (_item$control3$_activ = (_item$control3 = item.control)[_activeValue = 'active-value']) !== null && _item$control3$_activ !== void 0 ? _item$control3$_activ : _item$control3[_activeValue] = 1;
          (_item$control4$_inact = (_item$control4 = item.control)[_inactiveValue = 'inactive-value']) !== null && _item$control4$_inact !== void 0 ? _item$control4$_inact : _item$control4[_inactiveValue] = 0;
        } else if (['wl-dialog-select'].indexOf(item.control.is) > -1) _this2.setFormSelectorControl(item);

        /* 带 options 参数的组件 */
        _this2.setControlOptions(item);

        /* 监听数据变动，传递给表单 */
        // eslint-disable-next-line no-console
        if (!Object.keys(_this2.form).includes(item.code)) console.warn("\u8868\u5355 form \u4E2D\u4E0D\u5B58\u5728".concat(item.code, " \u5B57\u6BB5"));

        /* placeholder 输入提示文字 */
        if (typeof item.placeholder !== 'undefined') {
          item.control.placeholder = item.placeholder;
          delete item.placeholder;
        } else {
          var _item$control5, _item$control5$placeh;
          (_item$control5$placeh = (_item$control5 = item.control).placeholder) !== null && _item$control5$placeh !== void 0 ? _item$control5$placeh : _item$control5.placeholder = "\u8BF7".concat(item.control.is === 'el-input' ? '输入' : '选择', " ").concat(item.label);
        }
        (_item$prop = item.prop) !== null && _item$prop !== void 0 ? _item$prop : item.prop = (_item$props = item.props) !== null && _item$props !== void 0 ? _item$props : item.code;
        var rules = (_item$rule = item.rule) !== null && _item$rule !== void 0 ? _item$rule : _this2.rules ? _this2.rules[item.code] : {};
        if (_this2.$$isNoEmpty(rules)) (_item$rules = item.rules) !== null && _item$rules !== void 0 ? _item$rules : item.rules = rules;

        /* 监听数据变化  */
        _this2.setFormControlWatch(item);

        // console.log(item.code, { ...item }, { ...item.control })
      });
    },
    /** 设置 control options 数据源
     * @description: 如果该数据是方法，那么执行该方法，如果是 异步方法则 异步获取，如果是数组就正常返回
     * @param { Object } item 控件对象
     * @return { void }
     */
    setControlOptions: function setControlOptions(item) {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _item$control$options2;
        var options, arr, fun, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              options = (_item$control$options2 = item.control.options) !== null && _item$control$options2 !== void 0 ? _item$control$options2 : [];
              arr = [];
              if (!(typeof options === 'function')) {
                _context.n = 4;
                break;
              }
              fun = options();
              if (!(_this3.$$dataTypeOf(fun) === 'promise')) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return options(item);
            case 1:
              res = _context.v;
              if (Array.isArray(res)) arr.push.apply(arr, (0, _toConsumableArray2.default)(res));else if (Array.isArray(res.data)) arr.push.apply(arr, (0, _toConsumableArray2.default)(res.data));else if (Array.isArray(res.rows)) arr.push.apply(arr, (0, _toConsumableArray2.default)(res.rows));else arr.push(res);
              _context.n = 3;
              break;
            case 2:
              if (Array.isArray(fun)) {
                arr.push.apply(arr, (0, _toConsumableArray2.default)(fun));
              }
            case 3:
              if (_this3.$$isNoEmpty(arr)) item.control.options = arr;
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /** 设置 表单 数据监听
     * @description: 设置 表单 输入控件的数据相互监听 数据监听
     * @param { Object } item 控件对象
     * @return { void }
     */
    setFormControlWatch: function setFormControlWatch(item) {
      var _this4 = this;
      // if (item.code === 'imageUrl' || item.code === 'title') {
      //   console.log('item.code', item.code)
      //   console.log('item.value', this.form[item.code])
      //   console.log('item', item)
      //   console.log('form', this.form)
      // }

      if (item.value) this.form[item.code] = item.value;else if (this.form[item.code]) item.value = this.form[item.code];
      item.valueFormWatch = this.$watch(function () {
        return _this4.form[item.code];
      }, function (nv) {
        return item.value = nv !== null && nv !== void 0 ? nv : '';
      });
      item.valueWatch = this.$watch(function () {
        return item.value;
      }, function (nv) {
        return _this4.form[item.code] = nv !== null && nv !== void 0 ? nv : '';
      });
      if (item.control.is === 'el-input-number') {
        /* 这个监听的目的是因为 这个组件 输入框输入的时候，并不会返回输入的结果，要等到组件失去焦点之后才会返回输入的结果 */
        /* 注释原因：解决输入框输入一个数字会立即返回结果，不能连续输入两及以上位数数字 */
        this.$nextTick(function () {
          var _ref2;
          var ref = (_ref2 = (0, _toConsumableArray2.default)(_this4.$refs['wl-form-controls'])) === null || _ref2 === void 0 ? void 0 : _ref2.find(function (r) {
            return r.$attrs['component-code'] === item.code;
          });
          if (!ref) return;

          // 添加 change 事件监听
          ref.$on('change', function (value) {
            _this4.form[item.code] = value;
          });

          // item.inputNumberValueWatch = this.$watch(
          //   () => ref.userInput,
          //   (nv/* , ov */) => {
          //     if ((/^(-?\d+)(\.\d+)?$/).test(nv)) item.value = nv
          //   }
          // )

          // console.log(ref.userInput)
        });
      }

      // console.groupEnd()
    },
    /** 设置 表单 输入控件
     * @description: 表单输入控件
     * @param { Object } item 控件对象
     * @return { Object } 预设值后的控件参数对象
     */
    setFormIsControl: function setFormIsControl(item) {
      var _control$autosize, _listType, _control$_listType;
      var control = item.control;
      switch (item.type) {
        /* selector 弹出对话框选择 */
        case 'selector':
          control.is = 'wl-dialog-select';
          break;
        /* select 下拉框选择 */
        case 'select':
        case 'status':
          control.is = 'el-select';
          break;
        /* switch 开关 */
        case 'switch':
          control.is = 'el-switch';
          break;
        /* textarea 富文本 */
        case 'textarea':
          control.is = 'el-input';
          control.type = 'textarea';
          control.autosize = (_control$autosize = control.autosize) !== null && _control$autosize !== void 0 ? _control$autosize : {
            minRows: 2,
            maxRows: 10
          };
          break;
        /* number 数字 */
        case 'num':
        case 'number':
          control.is = 'el-input-number';
          // control.precision = 4
          break;
        /* number 数字 */
        case 'time':
          control.is = 'el-time-picker';
          control.type = item.type;
          // item.control.
          break;
        case 'year':
        case 'month':
        case 'date':
        case 'dates':
        case 'week':
        case 'datetime':
        case 'datetimerange':
        case 'daterange':
        case 'monthrange':
          control.is = 'el-date-picker';
          control.type = item.type;
          break;
        /* upload-image 上传图片 */
        case 'upload-image':
          control.type = 'images';
          (_control$_listType = control[_listType = 'list-type']) !== null && _control$_listType !== void 0 ? _control$_listType : control[_listType] = 'picture-card';
        /* upload 上传 */
        // eslint-disable-next-line no-fallthrough
        case 'upload':
          control.is = 'wl-upload';
          break;
        case 'rich-text':
          control.is = 'wl-rich-text';
          break;
        case 'provinces-cascader':
          control.is = 'wl-provinces-cascader';
          break;
        /* 金额数字输入框 */
        case 'price':
          control.is = 'wl-input-price';
          break;
        /* 默认 */
        default:
          control.is = 'el-input';
          break;
      }
      return item;
    },
    /** 设置 表单 input 输入控件
     * @description: 表单输入控件
     * @param { Object } control 控件对象
     * @return { Object } 预设值后的控件参数对象
     */
    setFormInputControl: function setFormInputControl() {
      return {};
    } /* control */,
    /** 设置 表单 select 输入控件
     * @param { Object } item 控件对象
     * @return { Object } 预设值后的控件参数对象
     */
    setFormSelectControl: function setFormSelectControl(item) {
      var _ref3, _ref4, _ref5, _item$option;
      item.control.options = (_ref3 = (_ref4 = (_ref5 = (_item$option = item.option) !== null && _item$option !== void 0 ? _item$option : item.options) !== null && _ref5 !== void 0 ? _ref5 : item.control.option) !== null && _ref4 !== void 0 ? _ref4 : item.control.options) !== null && _ref3 !== void 0 ? _ref3 : [];
      delete item.option;
      delete item.options;
      delete item.control.option;
      return item;
    },
    /** 设置 表单 selector 输入控件
     * @param { Object } item 控件对象
     * @return { Object } 预设值后的控件参数对象
     */
    setFormSelectorControl: function setFormSelectorControl(item) {
      var _a0$dataSource, _a0$tableOptions, _a0$title, _item$title, _a0$selectorType, _ref6, _item$selectorType, _a0$query, _item$query, _a0$columns, _item$columns, _a0$chooseMode, _ref7, _item$chooseMode, _b0$url, _b0$method, _item$method, _c0$rowKey, _ref8, _item$rowKey, _c0$rowLabel, _ref9, _item$rowLabel, _item$treeUrl;
      /* 一些其他参数设置 */
      var a0 = item.control;
      (_a0$dataSource = a0.dataSource) !== null && _a0$dataSource !== void 0 ? _a0$dataSource : a0.dataSource = {};
      (_a0$tableOptions = a0.tableOptions) !== null && _a0$tableOptions !== void 0 ? _a0$tableOptions : a0.tableOptions = {};
      (_a0$title = a0.title) !== null && _a0$title !== void 0 ? _a0$title : a0.title = (_item$title = item.title) !== null && _item$title !== void 0 ? _item$title : item.label;
      (_a0$selectorType = a0.selectorType) !== null && _a0$selectorType !== void 0 ? _a0$selectorType : a0.selectorType = (_ref6 = (_item$selectorType = item.selectorType) !== null && _item$selectorType !== void 0 ? _item$selectorType : item['selector-type']) !== null && _ref6 !== void 0 ? _ref6 : '';
      (_a0$query = a0.query) !== null && _a0$query !== void 0 ? _a0$query : a0.query = (_item$query = item.query) !== null && _item$query !== void 0 ? _item$query : [];
      (_a0$columns = a0.columns) !== null && _a0$columns !== void 0 ? _a0$columns : a0.columns = (_item$columns = item.columns) !== null && _item$columns !== void 0 ? _item$columns : [];
      (_a0$chooseMode = a0.chooseMode) !== null && _a0$chooseMode !== void 0 ? _a0$chooseMode : a0.chooseMode = (_ref7 = (_item$chooseMode = item.chooseMode) !== null && _item$chooseMode !== void 0 ? _item$chooseMode : item['choose-mode']) !== null && _ref7 !== void 0 ? _ref7 : 'single';
      delete item.title;
      delete item.query;
      delete item.columns;
      delete item.chooseMode;
      delete item['choose-mode'];

      /* 处理数据源 */
      var b0 = item.control.dataSource;
      Object.assign(b0, item.dataSource);
      (_b0$url = b0.url) !== null && _b0$url !== void 0 ? _b0$url : b0.url = item.url;
      (_b0$method = b0.method) !== null && _b0$method !== void 0 ? _b0$method : b0.method = (_item$method = item.method) !== null && _item$method !== void 0 ? _item$method : 'POST';
      delete item.dataSource;
      delete item.url;
      delete item.method;

      /* 表格参数设置 */
      var c0 = a0.tableOptions;
      Object.assign(c0, item.tableOptions);
      (_c0$rowKey = c0.rowKey) !== null && _c0$rowKey !== void 0 ? _c0$rowKey : c0.rowKey = (_ref8 = (_item$rowKey = item.rowKey) !== null && _item$rowKey !== void 0 ? _item$rowKey : item['row-key']) !== null && _ref8 !== void 0 ? _ref8 : 'id';
      (_c0$rowLabel = c0.rowLabel) !== null && _c0$rowLabel !== void 0 ? _c0$rowLabel : c0.rowLabel = (_ref9 = (_item$rowLabel = item.rowLabel) !== null && _item$rowLabel !== void 0 ? _item$rowLabel : item['row-label']) !== null && _ref9 !== void 0 ? _ref9 : 'id';
      delete item.tableOptions;
      delete item.rowKey;
      delete item.rowLabel;
      delete item['row-key'];
      delete item['row-label'];
      var treeUrl = (_item$treeUrl = item['tree-url']) !== null && _item$treeUrl !== void 0 ? _item$treeUrl : item.treeUrl;
      if (treeUrl || this.$$isNoEmpty(item.treeSource)) {
        var _a0$treeSource, _a0$treeOptions, _d0$url, _d0$method, _ref0, _item$treeMethod, _e0$treeKey, _item$treeKey, _e0$treeLabel, _item$treeLabel;
        (_a0$treeSource = a0.treeSource) !== null && _a0$treeSource !== void 0 ? _a0$treeSource : a0.treeSource = {};
        (_a0$treeOptions = a0.treeOptions) !== null && _a0$treeOptions !== void 0 ? _a0$treeOptions : a0.treeOptions = {};

        /* 处理左树状图数据源 */
        var d0 = a0.treeSource;
        Object.assign(d0, item.treeSource);
        (_d0$url = d0.url) !== null && _d0$url !== void 0 ? _d0$url : d0.url = treeUrl;
        (_d0$method = d0.method) !== null && _d0$method !== void 0 ? _d0$method : d0.method = (_ref0 = (_item$treeMethod = item['tree-method']) !== null && _item$treeMethod !== void 0 ? _item$treeMethod : item.treeMethod) !== null && _ref0 !== void 0 ? _ref0 : 'POST';
        delete item.treeSource;
        delete item.treeUrl;
        delete item.treeMethod;

        /* 处理左树状图参数设置 */
        var e0 = a0.treeOptions;
        (_e0$treeKey = e0.treeKey) !== null && _e0$treeKey !== void 0 ? _e0$treeKey : e0.treeKey = (_item$treeKey = item.treeKey) !== null && _item$treeKey !== void 0 ? _item$treeKey : 'id';
        (_e0$treeLabel = e0.treeLabel) !== null && _e0$treeLabel !== void 0 ? _e0$treeLabel : e0.treeLabel = (_item$treeLabel = item.treeLabel) !== null && _item$treeLabel !== void 0 ? _item$treeLabel : 'id';
        Object.assign(e0, item.treeOptions);
        delete item.treeOptions;
        delete item.treeKey;
        delete item.treeLabel;
      }
      return item;
    },
    /** 设置 表单 Date 输入控件
     * @param { Object } item 控件对象
     * @return { Object } 预设值后的控件参数对象
     */
    setFormDateControl: function setFormDateControl(item) {
      var _item$control6, _item$control7;
      var format = item === null || item === void 0 || (_item$control6 = item.control) === null || _item$control6 === void 0 ? void 0 : _item$control6.format;
      // [ year | month | date | dates | week | datetime | datetimerange | daterange | monthrange ]
      var type = item === null || item === void 0 || (_item$control7 = item.control) === null || _item$control7 === void 0 ? void 0 : _item$control7.type;
      switch (type) {
        case 'year':
          format !== null && format !== void 0 ? format : format = 'yyyy';
          break;
        case 'month':
        case 'monthrange':
          format !== null && format !== void 0 ? format : format = 'yyyy-MM';
          break;
        case 'dates':
          format !== null && format !== void 0 ? format : format = 'yyyy-MM-dd';
          break;
        case 'week':
          format !== null && format !== void 0 ? format : format = 'yyyy 第 WW 周';
          break;
        case 'time':
          format !== null && format !== void 0 ? format : format = 'HH:mm:ss';
          break;
        case 'datetime':
        case 'datetimerange':
          format !== null && format !== void 0 ? format : format = 'yyyy-MM-dd HH:mm:ss';
          break;
        case 'date':
        case 'daterange':
        default:
          format !== null && format !== void 0 ? format : format = 'yyyy-MM-dd';
          break;
      }
      // 选中日期后的默认具体时刻
      if (!type.includes('range')) item.control['default-time'] = this.$$formatDate(new Date());
      Object.assign(item.control, (0, _objectSpread2.default)({
        // 显示在输入框中的格式
        format: format,
        // 可选，绑定值的格式。不指定则绑定值为 Date 对象
        'value-format': format
      }, item.control));
      return item;
    }
  }
};